<template>
  <layout>
    <page-header :header="$t('general.add')" />
    <div class="content">
      <resource-form @saved="returnBack" @cancelled="returnBack" />
    </div>
  </layout>
</template>

<script>
import ResourceForm from './Form.vue'

const resourceBase = 'billing-info'

export default {
  name: 'BillingInfoCreate',

  components: {
    ResourceForm,
  },

  methods: {
    returnBack() {
      this.$router.push({ name: `${resourceBase}` })
    },
  },
}
</script>
